import { Alert, Box, Button, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { getTesSalaryTableColumn, getTesSalaryTableRow } from "./helpers";
import {
  TesSalaryTableDocument,
  TesSalaryTableSelectionProvenance,
} from "./tesSalaryTablesApi";

type Props = {
  disabled?: boolean;
  hasTables: boolean;
  isUnavailableForZones?: boolean;
  onOpenPicker: () => void;
  selection?: TesSalaryTableSelectionProvenance | null;
  selectedTable?: TesSalaryTableDocument | null;
};

const TesSalaryTableSelectionSummary = ({
  disabled,
  hasTables,
  isUnavailableForZones,
  onOpenPicker,
  selection,
  selectedTable,
}: Props) => {
  const { t } = useTranslation("settings");
  const row = selection
    ? getTesSalaryTableRow(selectedTable, selection.rowId)
    : null;
  const column = selection
    ? getTesSalaryTableColumn(selectedTable, selection.columnId)
    : null;

  if (!hasTables && !selection && !isUnavailableForZones) return null;

  return (
    <Box display="flex" flexDirection="column" gap={1.5} minWidth={0}>
      <Box
        display="flex"
        alignItems="center"
        gap={1.5}
        flexWrap="nowrap"
        minWidth={0}
      >
        <Tooltip title={t("tesSalaryTablesPickFromTable")} describeChild>
          <Button
            variant="outlined"
            onClick={onOpenPicker}
            disabled={disabled || !hasTables || isUnavailableForZones}
            sx={{ flex: "0 0 auto" }}
          >
            {t("tesSalaryTablesPickFromTableShort")}
          </Button>
        </Tooltip>
        {selection && (
          <Typography color="text.secondary" noWrap minWidth={0}>
            {(selectedTable?.name || selection.tesSalaryTableId) +
              (selectedTable ? ` (${selectedTable?.effectiveDate})` : "")}
            {` / ${row?.label || selection.rowId}`}
            {` / ${column?.label || selection.columnId}`}
            {selection.mode === "INFO_ONLY"
              ? ` (${t("tesSalaryTablesSelectionInfoOnly")})`
              : ""}
          </Typography>
        )}
      </Box>

      {isUnavailableForZones && (
        <Alert severity="info">{t("tesSalaryTablesUnavailableForZones")}</Alert>
      )}
    </Box>
  );
};

export default TesSalaryTableSelectionSummary;
